import { FilterKey } from "@studyportals/search-filters";
import { RouteFilter } from "../RouteFilter";
import { RouteFragment } from "../RouteFragment";
import { ContinentPresenter } from "@/presenters/ContinentPresenter";
import { RouteParams } from "../RouteParams";
import { RouteFragmentDetails } from "../RouteFragmentDetails";

export class RouteContinent extends RouteFilter {

	public static readonly fragmentType: typeof RouteContinent = RouteContinent;

	public constructor() {
		super("Continent", FilterKey.CONTINENT,
			new RouteFragmentDetails(RouteParams.CONTINENT, ContinentPresenter.allWithPaths())
		);
	}

	public instantiate(): RouteFragment {
		return new RouteContinent();
	}    
}
